// F-SOURCES — plug the real Sources pane into the F-SHELL registry seam.
//
// This is the FIRST proof of the seam (plan §2.1): a feature registers via its
// own `register.ts` calling `registerTab({...})`, the barrel `features/index.ts`
// imports it as a side-effect, and the shell renders the Pane — with ZERO edit
// to any shared shell file. The acceptance gate is an EMPTY
// `git diff origin/main -- src/ui/shell/`.
//
// `labelKey` REUSES the F-SHELL key `shell.tab.sources` (does not duplicate it);
// `order: 10` matches the FROZEN `KNOWN_TABS` slot.

import { createElement } from 'react'
import { registerTab } from '@/ui/shell/tab-registry'
import { SourcesPane } from './SourcesPane'

registerTab({
  id: 'sources',
  order: 10,
  labelKey: 'shell.tab.sources',
  // Neutral document glyph (RTL-agnostic — not a direction-implying icon, so
  // no scaleX flip needed per CLAUDE.md §9.2 rule 3).
  icon: createElement('span', { 'aria-hidden': true }, '§'),
  Pane: SourcesPane,
})
